/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Edit.scss'
import React from 'react'
import r from '../../../util/Renderer'
import nl2br from 'react-nl2br'
import Dropdown from '../../atoms/input/Dropdown'
import DatePicker from '../../atoms/input/DatePicker'
import { Edit } from '../../molecules'
import Date from '../../unit/Date'
import Money from '../../unit/Money'
import DailyClosingAction from '../../../action/daily_closing'
import MoneyInput from '../../unit/MoneyInput'
import ClosingStatus from '../../../domain/model/closing/Status'
import { CarefulButton, DangerButton, NormalButton, OutlinedButton } from 'ui-library/dist/external/components'
import { Link } from 'react-router-dom'
import { Status, NoShow } from '../../parts/Reservation'
import { ReservationStatusLabels } from '../../../store/state/ReservationState'

function EditView(props, readonly = false) {
  const id = props.head.id
  const onRequestSave = id
    ? status => DailyClosingAction.onRequestUpdate(id, status, props.head, props.details, props.view.deleted_ids, props.daily_closing_reservations, props.view.deleted_reservation_ids)
    : status => DailyClosingAction.onRequestCreate(status, props.head, props.details, props.daily_closing_reservations)

  const disabled = ClosingStatus.CLOSED === props.head.status || readonly

  const year_options = [
    { value: '', label: '未選択' },
    { value: '2018', label: '2018年' },
    { value: '2019', label: '2019年' },
    { value: '2020', label: '2020年' },
    { value: '2021', label: '2021年' },
    { value: '2022', label: '2022年' }
  ]
  const month_options = [
    { value: '', label: '未選択' },
    { value: '1', label: '1月' },
    { value: '2', label: '2月' },
    { value: '3', label: '3月' },
    { value: '4', label: '4月' },
    { value: '5', label: '5月' },
    { value: '6', label: '6月' },
    { value: '7', label: '7月' },
    { value: '8', label: '8月' },
    { value: '9', label: '9月' },
    { value: '10', label: '10月' },
    { value: '11', label: '11月' },
    { value: '12', label: '12月' }
  ]

  return (
    <Edit title={'日次締め'} showButton={false} onCancel={DailyClosingAction.onCancelEditView}>
      <div className="dailyProcess">
        <div className="inputs">
          <table>
            <tbody>
              <tr>
                <th>締め状況</th>
                <td>
                  <DailyClosingStatus>{props.head.status}</DailyClosingStatus>
                </td>
              </tr>
              <tr>
                <th>
                  締め日
                  <span className="required">*</span>
                </th>
                <td>
                  <DatePicker
                    style={{ display: 'inline-block' }}
                    className="closeDate"
                    name="close_date"
                    selected={props.head.close_date ? props.head.close_date.toJSDate() : null}
                    showTimeSelect={false}
                    isClearable={false}
                    placeholderText=""
                    onChange={DailyClosingAction.onEdit}
                    disabled={disabled}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  締め月<span className="required">*</span>
                </th>
                <td>
                  <SelectYear name="monthly_close_date_year" onChange={DailyClosingAction.onEdit} options={year_options} selected={props.head.monthly_close_date_year} disabled={disabled} />
                  &nbsp;
                  <SelectMonth name="monthly_close_date_month" onChange={DailyClosingAction.onEdit} options={month_options} selected={props.head.monthly_close_date_month} disabled={disabled} />
                </td>
              </tr>
              <tr>
                <th>宿泊施設</th>
                <td>{props.head.room_name}</td>
              </tr>
            </tbody>
          </table>
          <br />
        </div>

        <div className="inputs">
          <h3>宿泊予約</h3>
          <table>
            <tbody>
              {r.renderIf(props.daily_closing_reservations)(
                <React.Fragment>
                  {props.daily_closing_reservations.map((daily_closing_reservation, key) => {
                    const onChangeReservation = e => {
                      DailyClosingAction.onEditReservation(e, key)
                    }
                    const paddingLeft = { paddingLeft: '8px' }
                    const reservationHeaderStyle = { paddingLeft: '8px', textAlign: 'left' }
                    const tax = daily_closing_reservation.reservation.accommodation_tax || {}
                    const accom_tax = tax ? Math.ceil(tax.tax_per_day * (tax.number_of_guests * tax.number_of_nights)) : 0

                    return (
                      <React.Fragment>
                        <tr>
                          <th colSpan={3} style={reservationHeaderStyle}>
                            宿泊予約 (
                            <Link to={`/reservation/${daily_closing_reservation.reservation.id}/detail`} target="_blank">
                              ID: {daily_closing_reservation.reservation.id}
                            </Link>
                            )&nbsp;&nbsp;
                            {r.renderIf(disabled === false)(
                              <a className="closeButton" href="#" onClick={e => DailyClosingAction.onDeleteReservation(e, daily_closing_reservation.reservation.id)}>
                                {' × '}
                              </a>
                            )}
                          </th>
                        </tr>
                        <tr>
                          <td style={paddingLeft} colSpan={3}>
                            <ReservationDetail key={key} reservation={daily_closing_reservation.reservation} accommodation_tax={daily_closing_reservation.accommodation_tax} disabled={disabled} />
                          </td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>宿泊料金</th>
                          <td className="two">
                            <MoneyInput name="rsvn_sales" value={daily_closing_reservation.rsvn_sales} onChange={onChangeReservation} disabled={disabled} />
                          </td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>決済手数料</th>
                          <td className="two">
                            <MoneyInput name="rsvn_pay_comsn" value={daily_closing_reservation.rsvn_pay_comsn} onChange={onChangeReservation} disabled={disabled} />
                          </td>
                          <td className="two">
                            <input
                              type="input"
                              name="rsvn_pay_code"
                              value={daily_closing_reservation.rsvn_pay_code || ''}
                              placeholder="決済コード"
                              onChange={onChangeReservation}
                              style={{ height: '38px' }}
                              disabled={disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>入金額</th>
                          <td className="two" style={{ textAlign: 'right', paddingRight: '30px' }}>
                            <Money>{daily_closing_reservation.rsvn_sales - daily_closing_reservation.rsvn_pay_comsn}</Money>
                          </td>
                          <td className="two">
                            <small>(※ 宿泊料金 - 決済手数料)</small>
                          </td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>
                            予約元<span className="required">*</span>
                          </th>
                          <td className="two">
                            <Dropdown
                              name="site_referrer_id"
                              options={props.site_referrer_options}
                              value={daily_closing_reservation.site_referrer_id}
                              onChange={onChangeReservation}
                              placeholder="未選択"
                              searchable={true}
                              isMulti={false}
                              disabled={disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>OTA手数料</th>
                          <td className="two">
                            <MoneyInput name="ota_comsn" value={daily_closing_reservation.ota_comsn || 0} onChange={onChangeReservation} disabled={disabled} />
                          </td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>宿泊税</th>
                          <td className="two" style={{ textAlign: 'right', paddingRight: '30px' }}>
                            <Money>{accom_tax || 0}</Money>
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>宿泊税 決済手数料</th>
                          <td className="two">
                            <MoneyInput name="accom_pay_comsn" value={daily_closing_reservation.accom_pay_comsn || 0} onChange={onChangeReservation} disabled={disabled} />
                          </td>
                          <td className="two">
                            <input
                              type="input"
                              name="accom_pay_code"
                              value={daily_closing_reservation.accom_pay_code || ''}
                              placeholder="決済コード"
                              onChange={onChangeReservation}
                              style={{ height: '38px' }}
                              disabled={disabled}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th style={paddingLeft}>入金額</th>
                          <td className="two" style={{ textAlign: 'right', paddingRight: '30px' }}>
                            <Money>{accom_tax - daily_closing_reservation.accom_pay_comsn}</Money>
                          </td>
                          <td className="two">
                            <small>(※ 宿泊税 - 決済手数料)</small>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  })}
                </React.Fragment>
              )}
            </tbody>
          </table>
        </div>

        <br />
        <br />

        <div className="inputs">
          <br style={{ clear: 'both' }} />
          <h3>その他売上・原価・販管費</h3>
          <DailyClosingDetails options={props.account_title_detail_options} disabled={disabled}>
            {props.details}
          </DailyClosingDetails>

          <div className="actions">
            {r.renderIf(disabled === false)(
              <NormalButton type="dark" size="lg" onClick={DailyClosingAction.addDetail}>
                + 項目追加
              </NormalButton>
            )}
          </div>

          <br style={{ clear: 'both' }} />

          <h4>メモ</h4>
          <textarea name="memo" value={props.head.memo || ''} onChange={DailyClosingAction.onEdit} disabled={disabled} />
        </div>

        <br />
        <p>最終更新者: {props.head.user_name || ''}</p>
        <br />
        <ActionButtons status={props.head.status} onClick={onRequestSave} dailyClosingHeadId={id} readonly={readonly} />
      </div>
    </Edit>
  )
}

function ActionButtons(props) {
  const onClick = props.onClick || (() => {})
  const status = props.status

  const onDelete = () => {
    if (window.confirm('日次締めを削除します。この操作は元に戻せません。\n本当によろしいですか？')) {
      DailyClosingAction.onRequestDelete(props.dailyClosingHeadId)
    }
  }

  return r.renderIf(!props.readonly)(
    <div className="actions">
      {r.renderIfOrElse(status === ClosingStatus.CLOSED)(
        <CarefulButton type="danger" size="lg" onClick={e => onClick(ClosingStatus.SAVED)}>
          日次締め解除
        </CarefulButton>
      )(
        <div>
          <OutlinedButton type="primary" size="lg" onClick={e => onClick(ClosingStatus.CLOSED)}>
            日次締め
          </OutlinedButton>
          <NormalButton type="dark" size="lg" onClick={e => onClick(ClosingStatus.SAVED)}>
            保存
          </NormalButton>
        </div>
      )}
      {r.renderIf(status === ClosingStatus.SAVED)(
        <DangerButton style={{ float: 'left' }} onClick={onDelete}>
          削除
        </DangerButton>
      )}
    </div>
  )
}

function DailyClosingStatus(props) {
  const status = props.children || ClosingStatus.NONE
  return <span className={`status status--${status}`}>{ClosingStatus.getLabel(status)}</span>
}

function DailyClosingDetails(props) {
  const details = props.children
  if (details.length === 0) return null

  return (
    <table>
      <tbody>
        {details.map((row, index) => (
          <DetailInputRow key={index} index={index} options={props.options} disabled={props.disabled}>
            {row}
          </DetailInputRow>
        ))}
      </tbody>
    </table>
  )
}

function DetailInputRow(props) {
  const index = props.index
  const item = props.children
  const disabled = props.disabled

  function onChange(e) {
    DailyClosingAction.onEditDetail(e, index)
  }

  return (
    <tr>
      <td className="three--1">
        <Dropdown
          name="account_title_detail_id"
          options={props.options}
          value={item.account_title_detail_id}
          onChange={onChange}
          placeholder="選択"
          searchable={true}
          isMulti={false}
          disabled={disabled}
        />
      </td>
      <td className="three--2">
        <MoneyInput name="price" value={item.price} onChange={onChange} disabled={disabled} />円
      </td>
      <td className="three">
        <input type="input" name="remarks" value={item.remarks || ''} placeholder="備考" onChange={onChange} style={{ height: '38px', marginLeft: '6px' }} disabled={disabled} />
      </td>
      <td className="three--close">
        {r.renderIf(disabled === false)(
          <a className="closeButton" href="#" onClick={e => DailyClosingAction.onDeleteDetail(e, index, item.id)}>
            {' × '}
          </a>
        )}
      </td>
    </tr>
  )
}

function SelectYear(props) {
  const options = props.options || []
  const onChange = props.onChange || (() => {})
  const selected = props.selected || null

  return (
    <select name={props.name} value={selected} onChange={onChange} disabled={props.disabled}>
      {options.map((option, idx) => (
        <option key={idx} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

function SelectMonth(props) {
  const options = props.options || []
  const onChange = props.onChange || (() => {})
  const selected = props.selected || null

  return (
    <select name={props.name} value={selected} onChange={onChange} disabled={props.disabled}>
      {options.map((option, idx) => (
        <option key={idx} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

class ReservationDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showMore: false
    }
  }

  showDetail(event) {
    event.preventDefault()
    this.setState({ showMore: !this.state.showMore })
  }

  render() {
    const tax = this.props.reservation.accommodation_tax
    const accom_tax = tax ? Math.ceil(tax.tax_per_day * (tax.number_of_guests * tax.number_of_nights)) : 0

    return (
      <div style={{ clear: 'both' }}>
        <Date>{this.props.reservation.check_in}</Date> ~ <Date>{this.props.reservation.check_out}</Date>
        <small>
          <a href="#" onClick={e => this.showDetail(e)}>
            &nbsp;&nbsp;[詳細]
          </a>
        </small>
        <br />
        <span style={{ float: 'right' }}>
          <Status type={this.props.reservation.status}>{ReservationStatusLabels[this.props.reservation.status] || '不明'}</Status> &nbsp;
          {r.renderIf(this.props.reservation.noshow)(<NoShow>ノーショー</NoShow>)}
          &nbsp; &nbsp; {this.props.reservation.name} 様 &nbsp;
        </span>
        {r.renderIf(this.state.showMore)(
          <table style={{ width: '480px' }}>
            <colgroup>
              <col width="120px" />
              <col width="360px" />
            </colgroup>
            <tbody>
              <tr style={{ height: '24px' }}>
                <td>メール</td>
                <td style={{ wordBreak: 'break-all' }}>{this.props.reservation.email}</td>
              </tr>
              <tr style={{ height: '24px' }}>
                <td>料金</td>
                <td style={{ wordBreak: 'break-all' }}>
                  <Money>{this.props.reservation.accommodation_fee}</Money>
                </td>
              </tr>
              <tr style={{ height: '24px' }}>
                <td>宿泊税</td>
                <td style={{ wordBreak: 'break-all' }}>
                  <Money>{accom_tax}</Money>
                </td>
              </tr>
              <tr style={{ height: '24px' }}>
                <td>予約元</td>
                <td style={{ wordBreak: 'break-all' }}>{this.props.reservation.site_referer}</td>
              </tr>
              <tr style={{ height: '24px' }}>
                <td>OTA手数料</td>
                <td style={{ wordBreak: 'break-all' }}>
                  <Money>{this.props.reservation.commission}</Money>
                </td>
              </tr>
              <tr style={{ height: '24px' }}>
                <td>予約番号</td>
                <td style={{ wordBreak: 'break-all' }}>{this.props.reservation.reservation_code}</td>
              </tr>
              <tr style={{ height: '24px' }}>
                <td>ノート</td>
                <td>{nl2br(this.props.reservation.notes)}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    )
  }
}

export default EditView
